
import { button } from "@entersekt/types/build/3-5-0/endpoint";
import LoadingComponent from "@/components/LoadingComponent.vue";
import { defineComponent, PropType } from "vue";
import tinycolor from "tinycolor2";

const black = "black";
const white = "white";

const __default__ = defineComponent({
  name: "ButtonComponent",
  components: { LoadingComponent },

  data() {
    return {
      isLoading: false,
    };
  },

  props: {
    button: {
      required: true,
      type: Object as PropType<button>,
    },
    theme: {
      required: true,
      type: String,
    },
  },

  watch: {
    button: {
      handler() {
        this.isLoading = false;
      },
      deep: true,
    },
  },

  computed: {
    textColor() {
      const currentColor = tinycolor(this.theme);
      if (currentColor.isLight()) {
        return black;
      }
      return white;
    },

    onHover(): string {
      const currentColor = tinycolor(this.theme);
      if (currentColor.isLight()) {
        return currentColor.darken(10).toString();
      }
      return currentColor.lighten(10).toString();
    },
  },

  methods: {
    buttonClicked() {
      this.isLoading = true;
      this.$emit("buttonClicked", this.button.action, this.button.actionNext);
    },
  },

  emits: ["buttonClicked"],
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "303b4312": (_ctx.theme),
  "0b992eff": (_ctx.textColor),
  "0e9d3da6": (_ctx.onHover)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__